import { render, staticRenderFns } from "./colorPicker.vue?vue&type=template&id=827b19aa&scoped=true&lang=pug&"
import script from "./colorPicker.vue?vue&type=script&lang=js&"
export * from "./colorPicker.vue?vue&type=script&lang=js&"
import style0 from "./colorPicker.vue?vue&type=style&index=0&id=827b19aa&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "827b19aa",
  null
  
)

export default component.exports